import React from 'react'

import LiveSelect from 'live/components/forms/ui/select'

import { Comparator, ComparatorOption } from '../styles/editor'

const labels = {
    '>': ' (greater than)',
    '>=': ' (greater than or equal)',
    '<': ' (less than)',
    '<=': ' (less than or equal)',
    'in range': '',
    'outside range': ''
}

const labelsRigstate = {
    in: '',
    'not in': ''
}

type ComparatorSelectorProps = {
    value: ComparatorOp | ''
    onChange: (option: ComparatorOp, changeThreshold: boolean, toRange: boolean) => void
    disabled: boolean
    sideview: boolean
    state: ConditionsEditorState
}

const ComparatorSelector = ({
    value: operator,
    onChange,
    disabled,
    sideview,
    state
}: ComparatorSelectorProps): React.ReactElement => {
    return (
        <LiveSelect
            noFormGroup
            clearable={false}
            searchable={false}
            disabled={disabled}
            placeholder="Select operator..."
            options={Object.keys(state.channel === 'rigstate' ? labelsRigstate : labels).map(op => ({
                label: op + (sideview ? '' : { ...labels, ...labelsRigstate }[op]),
                title: op + { ...labels, ...labelsRigstate }[op],
                value: op
            }))}
            value={operator}
            className="Select-small"
            valueRenderer={(option: { label: string; value: ComparatorOp }) => (
                <Comparator>
                    <span>{option.value}</span>
                    {sideview ? null : option.label.slice(option.value.length)}
                </Comparator>
            )}
            optionComponent={ComparatorOption}
            onChange={(option: ComparatorOp) => {
                const optionIsRange = option === 'in range' || option === 'outside range'
                const currentIsRange = state.comparator === 'in range' || state.comparator === 'outside range'

                onChange(option, optionIsRange !== currentIsRange, optionIsRange)
            }}
        />
    )
}

export default ComparatorSelector
